import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { useModal } from '../../context/ModalContext';
import { Loader } from 'lucide-react';

const SwipeToRefresh = ({
  children,
  onSwipeDown,
}: {
  children: React.ReactNode;
  onSwipeDown: () => void;
}) => {
  const [isTopOfScreen, setIsTopOfScreen] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { isAnyModalOpen } = useModal();

  const handlers = useSwipeable({
    onTouchStartOrOnMouseDown: () => {
      const container = document.getElementById('swipe-scroll');
      if (!container) return;
      const containerInitialTop = container.offsetTop;
      const containerRect = container.children.length
        ? container.children[0].getBoundingClientRect()
        : { top: 0 };

      setIsTopOfScreen(Math.abs(containerInitialTop - containerRect.top) < 2);
    },
    onSwiping: (eventData) => {
      if (isTopOfScreen && !isAnyModalOpen && eventData.deltaY > 0) {
        setPullDistance(Math.min(eventData.deltaY, 100));
      }
    },
    onSwipedDown: async (eventData) => {
      if (isTopOfScreen && !isAnyModalOpen && eventData.deltaY > 30) {
        setIsRefreshing(true);
        setPullDistance(1);
        await onSwipeDown();
        setIsRefreshing(false);
        setPullDistance(0);
      } else {
        setPullDistance(0);
      }
    },
    delta: 30,
    trackMouse: true,
    trackTouch: true,
  });

  return (
    <div
      {...handlers}
      id='swipe-scroll'
      style={{
        overflowY: 'auto',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          height: pullDistance,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: isRefreshing ? 'height 0.2s' : 'height 0.1s',
        }}
      >
        <Loader
          style={{
            transform: `rotate(${pullDistance * 3.6}deg)`,
            transition: 'transform 0.1s',
            fontSize: 24,
            opacity: pullDistance > 30 ? 1 : 0,
          }}
        />
      </div>
      {children}
    </div>
  );
};

export default SwipeToRefresh;
